var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showmask)?_c('div',{staticClass:"maskTips",on:{"click":_vm.hide}},[_c('div',{staticClass:"curTips"},[_c('el-image',{attrs:{"src":_vm.point,"fit":"contain"}}),_c('p',[_vm._v("双击")]),_c('p',[_vm._v("放大/独立显示")])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }